const QUICK_PLACEHOLDERS = {
    Customer: [
        {
            label: 'First Name',
            value: '{{customer.primaryAddress.firstName}}',
        },
        {
            label: 'Last Name',
            value: '{{customer.primaryAddress.lastName}}',
        },
        {
            label: 'Full Address',
            value: '{{customer.primaryAddress.organization}}<br>{{customer.primaryAddress.address}} {{customer.primaryAddress.address2}}<br>{{customer.primaryAddress.city}} {{customer.primaryAddress.region}} {{customer.primaryAddress.postalCode}}<br>{{customer.primaryAddress.country}}<br>{{customer.primaryAddress.phoneNumbers.0.primary}}',
            textFallbackValue: '{{customer.primaryAddress.organization}} {{customer.primaryAddress.address}} {{customer.primaryAddress.address2}} {{customer.primaryAddress.city}} {{customer.primaryAddress.region}} {{customer.primaryAddress.postalCode}} {{customer.primaryAddress.country}} {{customer.primaryAddress.phoneNumbers.0.primary}}',
        },
    ],
    Dispute: [
        {
            label: 'First Name',
            value: '{{dispute.transaction.billingAddress.firstName}}',
        },
        {
            label: 'Last Name',
            value: '{{dispute.transaction.billingAddress.lastName}}',
        },
        {
            label: 'Full Address',
            value: '{{dispute.transaction.billingAddress.organization}}<br>{{dispute.transaction.billingAddress.address}} {{dispute.transaction.billingAddress.address2}}<br>{{dispute.transaction.billingAddress.city}} {{dispute.transaction.billingAddress.region}} {{dispute.transaction.billingAddress.postalCode}}<br>{{dispute.transaction.billingAddress.country}}<br>{{dispute.transaction.billingAddress.phoneNumbers.0.primary}}',
            textFallbackValue: '{{dispute.transaction.billingAddress.organization}} {{dispute.transaction.billingAddress.address}} {{dispute.transaction.billingAddress.address2}} {{dispute.transaction.billingAddress.city}} {{dispute.transaction.billingAddress.region}} {{dispute.transaction.billingAddress.postalCode}} {{dispute.transaction.billingAddress.country}} {{dispute.transaction.billingAddress.phoneNumbers.0.primary}}',
        },
    ],
    Invoice: [
        {
            label: 'First Name',
            value: '{{invoice.billingAddress.firstName}}',
        },
        {
            label: 'Last Name',
            value: '{{invoice.billingAddress.lastName}}',
        },
        {
            label: 'Full Address',
            value: '{{invoice.billingAddress.organization}}<br>{{invoice.billingAddress.address}} {{invoice.billingAddress.address2}}<br>{{invoice.billingAddress.city}} {{invoice.billingAddress.region}} {{invoice.billingAddress.postalCode}}<br>{{invoice.billingAddress.country}}<br>{{invoice.billingAddress.phoneNumbers.0.primary}}',
            textFallbackValue: '{{invoice.billingAddress.organization}} {{invoice.billingAddress.address}} {{invoice.billingAddress.address2}} {{invoice.billingAddress.city}} {{invoice.billingAddress.region}} {{invoice.billingAddress.postalCode}} {{invoice.billingAddress.country}} {{invoice.billingAddress.phoneNumbers.0.primary}}',

        },
        {
            label: 'Invoice Amount Due',
            value: '{{invoice.amountDue}}',
        },
        {
            label: 'Invoice Due Date',
            value: '{{invoice.dueTime}}',
        },
    ],
    PaymentCard: [
        {
            label: 'First Name',
            value: '{{paymentCard.billingAddress.firstName}}',
        },
        {
            label: 'Last Name',
            value: '{{paymentCard.billingAddress.lastName}}',
        },
        {
            label: 'Full Address',
            value: '{{paymentCard.billingAddress.organization}}<br>{{paymentCard.billingAddress.address}} {{paymentCard.billingAddress.address2}}<br>{{paymentCard.billingAddress.city}} {{paymentCard.billingAddress.region}} {{paymentCard.billingAddress.postalCode}}<br>{{paymentCard.billingAddress.country}}<br>{{paymentCard.billingAddress.phoneNumbers.0.primary}}',
            textFallbackValue: '{{paymentCard.billingAddress.organization}} {{paymentCard.billingAddress.address}} {{paymentCard.billingAddress.address2}}  {{paymentCard.billingAddress.city}} {{paymentCard.billingAddress.region}} {{paymentCard.billingAddress.postalCode}} {{paymentCard.billingAddress.country}} {{paymentCard.billingAddress.phoneNumbers.0.primary}}',
        },
        {
            label: 'Payment Card Brand',
            value: '{{paymentCard.brand}}',
        },
    ],
    Subscription: [],
    Transaction: [],
};

export default QUICK_PLACEHOLDERS;
